import { Stack, TooltipHost } from "@fluentui/react";
import React, { useContext, useEffect } from "react";
import ReportCount from "../../../components/SVGComponents/ReportCount";
import ImageCount from "../../../components/SVGComponents/ImageCount";
import RowBadge from "./Badge/RowBadge";
import { useNavigate } from "react-router";
import { getClientWarningStatus } from "../../../service/FirmServices";
import { t } from "i18next";
import {
  ACTIONS,
  AuthRoutes,
  CUSTOM_STYLES,
  TAB_NAME,
  USERTYPES,
} from "../../../constants/Constants";
import { RowBadgeStatic } from "./RadiologistDetails";
import userContext from "../../../context/users/UserContext";
import CustomToolTipHost from "../../../components/CustomToolTipHost/CustomToolTipHost";

const mainStackStyles = {
  // lineHeight: "20px",
  // height: "121px",
  // width: "210px",
  justifyContent: "center",
  marginTop: CUSTOM_STYLES.STUDYLIST_TD_TOP_MARGIN,
  // transform: "translateY(-39%)"
};

const hospitalStackStyles = {
  fontSize: "14px",
  fontWeight: "400",
  alignItems: "center",
  marginTop: "4px",
};

const modalityStyle = {
  marginLeft: "10px",
  backgroundColor: "#BBDEFF",
  height: "14px",
  fontSize: "9px",
  color: "#0035BE",
  display: "flex",
  alignItems: "center",
  width: "fit-content",
  fontWeight: "bolder",
  padding: "0px 5px",
  borderRadius: "5px",
};

const studyUploadDateStyle = {
  fontSize: "11px",
  fontWeight: "400",
};

const studyDetailsStackStyle = {
  alignItems: "center",
};

const studyDescriptionStyle = {
  fontSize: "11px",
  fontWeight: "400",
  marginRight: "20px",
};

const studyDetailsIconTextStyle = {
  fontSize: "14px",
  fontWeight: "400",
};

const QCDetails = (props) => {
  const { roles, authenticated, loadByUsername, showConfirmation } =
    useContext(userContext);

  return (
    <>
      <Stack style={mainStackStyles}>
        {props.data.row.depth === 0 && <div>
          {((roles[0] == USERTYPES.SUPERVISOR && props.tabId == TAB_NAME.QCFIX ||
            roles[0] == USERTYPES.FIRMADMIN && props.tabId == TAB_NAME.QCFIX)
            ) && (
              <Stack horizontal style={hospitalStackStyles}>
                {/* <span className="study-list-studyDetails-uploaded">Provider Firm :</span> */}
                <RowBadgeStatic name="QF" tooltipText={t("study-list.column.qc-fixer")} />
                {props.data.row.original.assignmentList[0].qcfixerId != null &&
                props.data.row.original.assignmentList[0].qcfixerId.startsWith(
                  "R"
                ) ? (
                  //  <RowBadge name={props.data.row.original.assignmentList[0].providerName} />

                  <span
                    className="study-list-assignment-details-text study-list-row-badge study-list-min-width"
                    style={{ width: "160px" }}
                  >
                    &nbsp;&nbsp;
                    <CustomToolTipHost
                      content={
                        props.data.row.original.assignmentList[0].qcfixerName
                      }
                      id={
                        "tooltip_" +
                        props.data.row.original.assignmentList[0].qcfixerName
                      }
                    >
                      {props.data.row.original.assignmentList[0].qcfixerName}{" "}
                    </CustomToolTipHost>
                  </span>
                ) : (
                  <>
                    <span className="study-list-assignment-details-text study-list-row-badge">
                      &nbsp;&nbsp;{t("label.not-assigned")}
                    </span>
                  </>
                )}
              </Stack>
            )}

{((roles[0] == USERTYPES.SUPERVISOR && (props.tabId === TAB_NAME.QCREVIEW || props.tabId === TAB_NAME.QCVERIFY) )||
            (roles[0] == USERTYPES.FIRMADMIN && (props.tabId === TAB_NAME.QCREVIEW || props.tabId === TAB_NAME.QCVERIFY)))  && (
              <Stack horizontal style={hospitalStackStyles}>
                {/* <span className="study-list-studyDetails-uploaded">Provider Firm :</span> */}
                <RowBadgeStatic name="QR" tooltipText={t("study-list.column.qc-reviewer")} />
                {props.data.row.original.assignmentList[0].qcreviewerId != null &&
                props.data.row.original.assignmentList[0].qcreviewerId.startsWith(
                  "S"
                ) ? (
                  //  <RowBadge name={props.data.row.original.assignmentList[0].providerName} />

                  <span
                    className="study-list-assignment-details-text study-list-row-badge study-list-min-width"
                    style={{ width: "160px" }}
                  >
                    &nbsp;&nbsp;
                    <CustomToolTipHost
                      content={
                        props.data.row.original.assignmentList[0].qcreviewerName
                      }
                      id={
                        "tooltip_" +
                        props.data.row.original.assignmentList[0].qcreviewerName
                      }
                    >
                      {props.data.row.original.assignmentList[0].qcreviewerName}{" "}
                    </CustomToolTipHost>
                  </span>
                ) : (
                  <>
                    <span className="study-list-assignment-details-text study-list-row-badge">
                      &nbsp;&nbsp;{t("label.not-assigned")}
                    </span>
                  </>
                )}
              </Stack>
            )}

{(((roles[0] == USERTYPES.SUPERVISOR && props.tabId === TAB_NAME.QCVERIFY ||
            (roles[0] == USERTYPES.FIRMADMIN && props.tabId == TAB_NAME.QCVERIFY)) 
           // && (props.tabId == TAB_NAME.QCFIX || props.tabId == TAB_NAME.QCVERIFY)
            )) && (
              <Stack horizontal style={hospitalStackStyles}>
                {/* <span className="study-list-studyDetails-uploaded">Provider Firm :</span> */}
                <RowBadgeStatic name="QV" tooltipText={t("study-list.column.qc-verifier")} />
                {props.data.row.original.assignmentList[0].qcverifierId != null &&
                props.data.row.original.assignmentList[0].qcverifierId.startsWith(
                  "S"
                ) ? (
                  //  <RowBadge name={props.data.row.original.assignmentList[0].providerName} />

                  <span
                    className="study-list-assignment-details-text study-list-row-badge study-list-min-width"
                    style={{ width: "160px" }}
                  >
                    &nbsp;&nbsp;
                    <CustomToolTipHost
                      content={
                        props.data.row.original.assignmentList[0].qcverifierName
                      }
                      id={
                        "tooltip_" +
                        props.data.row.original.assignmentList[0].qcverifierName
                      }
                    >
                      {props.data.row.original.assignmentList[0].qcverifierName}{" "}
                    </CustomToolTipHost>
                  </span>
                ) : (
                  <>
                    <span className="study-list-assignment-details-text study-list-row-badge">
                      &nbsp;&nbsp;{t("label.not-assigned")}
                    </span>
                  </>
                )}
              </Stack>
            )}

          {/* <span style={studyUploadDateStyle}>
            {`Uploaded on ${props.data.row.original.uploadDateDisplay}`}
          </span> */}
        </div>}
      </Stack>
    </>
  );
};

export default QCDetails;
